import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "../../react-auth0-spa";
import CorticaLoader from "../../components/sharedComponents/CorticaLoader/CorticaLoader";

const Login = () => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (loading || isAuthenticated) {
      return;
    }
    const fn = async () => {
      await loginWithRedirect({
        appState: { targetUrl: "/" },
      });
    };
    fn();
  }, [loading, isAuthenticated, loginWithRedirect]);

  if (isAuthenticated) return <Navigate to="/" />;
  else return <CorticaLoader message="Cortica Telehealth" />;
};

export default Login;
